<template>
  <div class="list">
    <div class="content-wrapper">
      <table class="table" v-if="!isEmpty(infoList)">
        <tr class="order-brief">
          <th class="black">
            课次
          </th>
          <th class="border">
            开始时间
          </th>
          <th class="border">
            结束时间
          </th>
          <th class="border">
            结算金额
          </th>
          <th>
            记录添加时间
          </th>
        </tr>
        <template v-for="(item,index) in infoList" v-if="(index>=(currentPage-1)*10)&&(index<currentPage*10)">
          <tr class="order-brief">
            <td>
              第{{totalPage-index}}节
            </td>
            <td>{{item.starttime.substring(0,16)}}</td>
            <td>{{item.endtime.substring(0,16)}}</td>
            <td>{{decodeURIComponent(item.amount)}}</td>
            <td>{{item.addtime.substring(0,16)}}</td>
          </tr>
        </template>
      </table>
      <template v-if="totalPage>10">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="totalPage">
        </el-pagination>
      </template>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import Vue from 'vue';
  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        currentPage: 1,
        totalPage: 1,
        infoList: [],
        classid: 0,
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      changeSwitch() {
        this.infoList = [];
        this.currentPage = 1;
        this.QueryRoomClassSettlement(1);
      },
      handleCurrentChange(val) {
        this.QueryRoomClassSettlement(val);
      },
      QueryRoomClassSettlement(pageNumber) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassHour',
            a: 'QueryRoomClassDetailSettlement',
            id: this.id,
            classid:this.classid,
            pageno: pageNumber,
            pagesize: 10,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.totalPage = Number(response.recordcount);
            let list = response.list;
            for (let i = 0; i < list.length; i++) {
              this.infoList[(pageNumber - 1) * 10 + i] = list[i];
            }
            this.$forceUpdate();
          }
        }).catch((err) => {
        })
      }
    },

    created() {
      const classid = this.$route.params && this.$route.params.classid;
      this.classid = classid;
      this.QueryRoomClassSettlement(1);
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .list
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
      .filter-wrapper
        margin-bottom: 20px
        padding-left: 10px
        height: 60px
        width: 100%
        font-size: 0
        background #fff
        box-sizing border-box
        .switch-wrapper
          float: left
          margin: 20px
          font-size: 16px
          color: #000000
      .no-result
        font-size: 18px
        color: #333
        text-align: center
      .table
        width: 1164px
        background: #ffffff
        text-align: center
        font-size: 0
        table-layout: fixed
        .order-brief
          border-bottom: 1px solid #e4e4e4
          &:last-child
            border: none
          th
            height: 40px
            line-height: 40px
            width: 194px
            font-size: 14px
            color: #999
            box-sizing: border-box
            &:first-child
              width: 244px
              border-right: 1px solid #e4e4e4
            &:last-child
              width: 144px
            &.black
              color: #000
            &.border
              position: relative
              &::after
                content: ''
                position: absolute
                top: 10px
                right: 0
                width: 0
                height: 20px
                border-right: 1px solid #e4e4e4

          td
            height: 50px
            line-height: 50px
            font-size: 14px
            color: #333
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            box-sizing: border-box
            a
              color:#333


</style>




// WEBPACK FOOTER //
// src/page/statistic/statisticinfo/statisticinfo.vue